import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import { CompareRemoveIcon } from '@modules/quantify/components/CompareRemoveIcon';
import { DEFAULT_QUANTIFY_SORT_BY } from '@modules/quantify/constants';
import { QuantifyActionType } from '@modules/quantify/store/quantifyActionType';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { trackQuantifyCompareEvents } from '@modules/quantify/utils';
import { CompareArrowsRounded } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';

interface CompareFieldGroupHeaderProps {
  title: string;
  subtitle: string;
  onRemove: () => void;
}

export const CompareFieldGroupHeader = ({
  title,
  subtitle,
  onRemove,
}: CompareFieldGroupHeaderProps) => {
  const dispatch = useQuantifyStore(({ dispatch }) => dispatch);

  const analysisLink = useAnalysisStore(({ href }) => href);

  const onRemoveCompare = () => {
    dispatch({
      type: QuantifyActionType.SET_QUERY,
      payload: {
        compareQuery: undefined,
        sortBy: DEFAULT_QUANTIFY_SORT_BY,
      },
    });

    dispatch({
      type: QuantifyActionType.SET_QUERY,
      payload: {
        shouldShowTopDataPoints: true,
        visibleDataPoints: [],
      },
    });

    dispatch({
      type: QuantifyActionType.SET_REPORT_DATA,
      payload: {
        compare: {
          tableRows: null,
          chartDataPoints: null,
        },
        quantify: {
          tableRows: null,
          chartDataPoints: null,
        },
      },
    });

    onRemove();
    trackQuantifyCompareEvents({
      eventName: 'Quantify Compare - Remove Button Clicked',
      link: analysisLink,
    });
  };

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Stack spacing={1} direction="row" alignItems="center">
        <CompareArrowsRounded
          sx={{
            color: 'text.secondary',
          }}
        />
        <Typography variant="subtitle1">{title}</Typography>
        <Typography variant="caption" color="text.secondary">
          ({subtitle}: A - B)
        </Typography>
      </Stack>
      <Button
        size="small"
        startIcon={<CompareRemoveIcon />}
        onClick={onRemoveCompare}
      >
        Remove
      </Button>
    </Stack>
  );
};
